<script setup>
import { BLink } from 'bootstrap-vue-next';

import UserWithGitLabProfileLink from '~/common/components/UserWithGitLabProfileLink.vue';

const bannerSrc = '/docs/images/notable-contributor/banner.svg';

defineProps({
  release: {
    type: Object,
    required: true,
  },
});
</script>

<template>
  <div>
    <img
      class="mw-100 mh-100 object-fit-contain"
      :src="bannerSrc"
      alt="Notable Contributor banner"
    >
    <h2 class="my-4">
      <BLink
        :href="release.releasePostUrl"
        target="_blank"
      >
        v{{ release.release }}
      </BLink>'s notable
      {{ release.contributors.length > 1 ? 'contributors are' : 'contributor is' }}
      <template
        v-for="(contributor, index) in release.contributors"
        :key="contributor.gitlabUsername"
      >
        <span v-if="index > 0"> and </span>
        <UserWithGitLabProfileLink
          :username="contributor.gitlabUsername"
          :name="contributor.name"
        />
      </template>
    </h2>
  </div>
</template>
